export default __webpack_public_path__ + "static/ds-zeroheight-lapierre-cover-d01759b435db06287dda481f930f8e8a.png";